import {
  MeetingPlatform,
  MeetingEmailNotification,
  MeetingJoinPreference,
} from '@distribute/shared/types';

import { IconMap } from '../../shared/sprite';
import { TabContent } from '../../shared/ui';

import { SpriteGlyph } from '../../shared/ui/Icon';

export enum CallDetailTab {
  SUMMARY = 'summary',
  TRANSCRIPT = 'transcript',
}

export const CALL_DETAIL_TABS: TabContent[] = [
  { name: CallDetailTab.SUMMARY, title: 'Summary', icon: IconMap.Document01 },
  {
    name: CallDetailTab.TRANSCRIPT,
    title: 'Transcript',
    icon: IconMap.Microphone02,
  },
];

export enum CallTab {
  MY_CALLS = 'my-calls',
  TEAM_CALLS = 'team-calls',
}

export const CALL_TABS: TabContent[] = [
  {
    name: CallTab.MY_CALLS,
    title: 'My Calls',
    icon: IconMap.Lead,
  },
  {
    name: CallTab.TEAM_CALLS,
    title: 'Team Calls',
    icon: IconMap.Building,
  },
];

export const MEETING_PLATFORMS: Record<
  MeetingPlatform,
  { name: string; icon: SpriteGlyph }
> = {
  googleMeet: {
    name: 'On Google Meet',
    icon: IconMap.GoogleMeet,
  },
  zoom: {
    name: 'On Zoom',
    icon: IconMap.ZoomCall,
  },
  microsoftTeams: {
    name: 'On Teams',
    icon: IconMap.TeamsCall,
  },
} as const;

export const JOIN_PREFERENCE_OPTIONS = [
  {
    name: 'join-all',
    value: MeetingJoinPreference.JOIN_ALL,
    label: 'Join all meetings in calendar',
  },
  {
    name: 'join-organized',
    value: MeetingJoinPreference.JOIN_ORGANIZED,
    label: 'Join only meetings I organize',
  },
  {
    name: 'join-external',
    value: MeetingJoinPreference.JOIN_EXTERNAL,
    label: 'Join only external meetings',
  },
  {
    name: 'no-auto-join',
    value: MeetingJoinPreference.NO_AUTO_JOIN,
    label: 'Don’t auto-join any meetings',
  },
] as const;

export const EMAIL_NOTIFICATION_OPTIONS = [
  {
    name: 'send-all',
    value: MeetingEmailNotification.ALL_PARTICIPANTS,
    label: 'Send email to all participants',
  },
  {
    name: 'send-internal',
    value: MeetingEmailNotification.INTERNAL_PARTICIPANTS,
    label: 'Send email to internal participants',
  },
  {
    name: 'send-me',
    value: MeetingEmailNotification.ONLY_ME,
    label: 'Send email only to me',
  },
  {
    name: 'no-email',
    value: MeetingEmailNotification.NO_EMAIL,
    label: 'Don’t send email at all',
  },
] as const;
